/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface PrepaidBankTransferMailingRequest
 */
export interface PrepaidBankTransferMailingRequest {
    /**
     * Amount to be printed on the payment slips
     * @type {number}
     * @memberof PrepaidBankTransferMailingRequest
     */
    amount: number;
    /**
     * 
     * @type {Currency}
     * @memberof PrepaidBankTransferMailingRequest
     */
    currency: Currency;
}

/**
 * Check if a given object implements the PrepaidBankTransferMailingRequest interface.
 */
export function instanceOfPrepaidBankTransferMailingRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "currency" in value;

    return isInstance;
}

export function PrepaidBankTransferMailingRequestFromJSON(json: any): PrepaidBankTransferMailingRequest {
    return PrepaidBankTransferMailingRequestFromJSONTyped(json, false);
}

export function PrepaidBankTransferMailingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrepaidBankTransferMailingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': CurrencyFromJSON(json['currency']),
    };
}

export function PrepaidBankTransferMailingRequestToJSON(value?: PrepaidBankTransferMailingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'currency': CurrencyToJSON(value.currency),
    };
}

